import { trim, isType } from "@utils";

const doc = window.document;
const LS_PREFIX = "yps_ck_";

function readLocal(key) {
  try {
    const raw = localStorage.getItem(LS_PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Object.prototype.hasOwnProperty.call(parsed, "v")) return null;
    if (parsed.exp && Date.now() > parsed.exp) {
      localStorage.removeItem(LS_PREFIX + key);
      return null;
    }
    return parsed.v;
  } catch (e) {
    return null;
  }
}

function writeLocal(key, data, exp) {
  try {
    localStorage.setItem(
      LS_PREFIX + key,
      JSON.stringify({ v: data, exp: exp || 0 })
    );
  } catch (e) {}
}

function removeLocal(key) {
  try {
    localStorage.removeItem(LS_PREFIX + key);
  } catch (e) {}
}

function get(key) {
  if (!key) return null;
  if (!_has(key)) return readLocal(key);

  let regexpStr =
    "(?:^|;\\s*)" +
    encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") +
    "\\s*=\\s*([^;]*)";

  try {
    const match = doc.cookie.match(new RegExp(regexpStr));
    if (!match) return readLocal(key);
    const cookieValue = decodeURIComponent(match[1]);
    return JSON.parse(cookieValue);
  } catch (e) {
    console.error("Cookie解析失败:", e);
    return readLocal(key);
  }
}

function all() {
  let cookies = doc.cookie.split(/; ?/g),
    data = {};
  for (let i = cookies.length - 1; i >= 0; i--) {
    if (!trim(cookies[i])) {
      continue;
    }
    let kvp = cookies[i].split("=");
    let key = decodeURIComponent(kvp[0]);
    data[key] = decodeURIComponent(kvp[1]);
  }
  return data;
}

function set(key, data, time) {
  if (!key) {
    return;
  }
  
  let expiresDate;
  if (isType(time, "Date") || time instanceof Date) {
    expiresDate = time;
  } else if (time) {
    expiresDate = new Date(time);
    if (isNaN(expiresDate.getTime())) {
      // 如果解析失败，使用默认过期时间
      //expiresDate = new Date('Tue, 19 Jan 2038 03:14:07 GMT');
      expiresDate = new Date('2038-11-10T12:00:00');
    }
  } else {
    // 默认过期时间：2038/1/19
    //expiresDate = new Date('Tue, 19 Jan 2038 03:14:07 GMT');
    expiresDate = new Date('2038-11-10T12:00:00');
  }
  
  const expiresStr = expiresDate.toUTCString();
  const seconds = Math.floor((expiresDate.getTime() - Date.now()) / 1000);
  const maxAge = seconds > 0 ? "; max-age=" + seconds : "";
  const secure = location.protocol === "https:" ? "; Secure" : "";

  try {
    const encodedValue = encodeURIComponent(JSON.stringify(data));
    doc.cookie =
      encodeURIComponent(key) +
      "=" +
      encodedValue +
      "; expires=" +
      expiresStr +
      maxAge +
      "; path=/; SameSite=Lax" +
      secure;
  } catch (e) {
    console.error("Cookie设置失败:", e);
  }
  writeLocal(key, data, expiresDate.getTime());
}

function formatDate(date) {
  var dates = new Date(date);
  var YY = dates.getFullYear() + "-";
  var MM =
    (dates.getMonth() + 1 < 10
      ? "0" + (dates.getMonth() + 1)
      : dates.getMonth() + 1) + "-";
  var DD = dates.getDate() < 10 ? "0" + dates.getDate() : dates.getDate();
  var hh =
    (dates.getHours() < 10 ? "0" + dates.getHours() : dates.getHours()) + ":";
  var mm =
    (dates.getMinutes() < 10 ? "0" + dates.getMinutes() : dates.getMinutes()) +
    ":";
  var ss =
    dates.getSeconds() < 10 ? "0" + dates.getSeconds() : dates.getSeconds();
  return YY + MM + DD + " " + hh + mm + ss;
}

function remove(key) {
  if (!key) return;
  if (_has(key)) {
    const expiresStr = new Date("Thu, 01 Jan 1970 00:00:00 GMT").toUTCString();
    const secure = location.protocol === "https:" ? "; Secure" : "";
    doc.cookie =
      encodeURIComponent(key) +
      "=; expires=" +
      expiresStr +
      "; max-age=0; path=/; SameSite=Lax" +
      secure;
  }
  removeLocal(key);
}

function clearAll() {
  Object.keys(all()).forEach(function(key) {
    remove(key);
  });
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.indexOf(LS_PREFIX) === 0) keys.push(k);
    }
    keys.forEach(function(k) {
      localStorage.removeItem(k);
    });
  } catch (e) {}
}

function _has(key) {
  const inCookie = new RegExp(
    "(?:^|;\\s*)" + encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") + "\\s*\\="
  ).test(doc.cookie);
  if (inCookie) return true;
  return readLocal(key) !== null;
}

export default {
  get,
  all,
  set,
  remove,
  clearAll,
  has: _has
};
